import { useLocale } from '../i18n/LocaleContext'
import { getHomePath } from '../utils/routes'
import Button from '../components/ui/Button'

export default function NotFound() {
  const { locale, t } = useLocale()

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
      <h1 className="text-8xl font-heading font-semibold text-primary mb-4">{t.notFound.title}</h1>
      <h2 className="text-2xl mb-2">{t.notFound.subtitle}</h2>
      <p className="text-text-secondary mb-8 max-w-md">{t.notFound.text}</p>
      <Button to={getHomePath(locale)}>{t.notFound.cta}</Button>
    </div>
  )
}
